import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 rounded-lg bg-[#f1f3f6] px-4 py-3 text-sm text-gray-700"
}
const _hoisted_2 = { class: "grid gap-4 sm:grid-cols-3" }
const _hoisted_3 = {
  key: 0,
  "data-area-map": ""
}
const _hoisted_4 = {
  key: 3,
  class: "m-0 text-sm text-gray-600"
}

import { computed } from 'vue'
import { useStore } from 'vuex'

import GoogleMapComponent from '@/components/GoogleMapComponent.vue'
import InputField from '@/components/neue/InputField.vue'
import MultiSelectInput from '@/components/neue/MultiSelectInput.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import ZipCodeList from '@/components/neue/wizard/ZipCodeList.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { ADDRESS_TYPES, sectionCopy, SHIPPING_AREAS, ZONE_KINDS } from '@/config/fulfillmentWizardSteps'
import australiaStates from '@/models/australiaStates'
import canadianStates from '@/models/canadianStates'
import unitedKingdomStates from '@/models/unitedKingdomStates'
import usaStates from '@/models/usaStates'

const ONE_KIND_NOTE = 'Only one of these applies. A zip code list does not add to a state list.'

export default {
  __name: 'StepWhere',
  setup(__props) {

const wizard = injectWizard()
const store = useStore()

const LIST_KINDS = ['zips', 'states']
const STATES_BY_COUNTRY = { USA: usaStates, AUS: australiaStates, CAN: canadianStates, GBR: unitedKingdomStates }
const STATE_WORDS = {
  USA: { one: 'State', many: 'states' },
  AUS: { one: 'State', many: 'states' },
  CAN: { one: 'Province', many: 'provinces' },
  GBR: { one: 'County', many: 'counties' }
}

const country = computed(() => store.getters.country)
const addressType = computed(() => ADDRESS_TYPES.includes(wizard.data.type))
const stateWords = computed(() => STATE_WORDS[country.value] ?? STATE_WORDS.USA)
const zipLabel = computed(() => (country.value === 'USA' ? 'Zip code' : 'Postal code'))
const zipLength = computed(() => ({ USA: 5, AUS: 4, CAN: 7, GBR: 7 })[country.value] ?? 5)
const stateOptions = computed(() =>
  (STATES_BY_COUNTRY[country.value] ?? usaStates).map(s => ({ name: s.label, value: s.value }))
)
const zoneCopy = computed(() => sectionCopy('zone', wizard.data))
const kindOptions = computed(() =>
  wizard.data.type === 'shipping'
    ? SHIPPING_AREAS.map(a => ({ name: a.label(country.value), value: a.value }))
    : ZONE_KINDS.map(k => ({ name: k.label, value: k.value }))
)
const listKind = computed(() => LIST_KINDS.includes(wizard.data.zone.kind))

return (_ctx, _cache) => {
  return (addressType.value)
    ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)('address', _unref(wizard).data))), {
        default: _withCtx(() => [
          (_unref(wizard).data.type === 'uber_direct')
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Uber delivers to addresses within about 10 miles of this point. Bottle quotes each delivery live at checkout and adds the courier fee to the delivery line. "))
            : _createCommentVNode("", true),
          _createVNode(InputField, {
            modelValue: _unref(wizard).data.address.address1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.address.address1) = $event)),
            name: "Address line 1"
          }, null, 8, ["modelValue"]),
          _createVNode(InputField, {
            modelValue: _unref(wizard).data.address.address2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(wizard).data.address.address2) = $event)),
            name: "Address line 2"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(InputField, {
              modelValue: _unref(wizard).data.address.city,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(wizard).data.address.city) = $event)),
              name: "City"
            }, null, 8, ["modelValue"]),
            _createVNode(SelectInput, {
              modelValue: _unref(wizard).data.address.state,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(wizard).data.address.state) = $event)),
              name: stateWords.value.one,
              options: stateOptions.value,
              placeholder: "Select"
            }, null, 8, ["modelValue", "name", "options"]),
            _createVNode(InputField, {
              modelValue: _unref(wizard).data.address.zip,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(wizard).data.address.zip) = $event)),
              name: zipLabel.value
            }, null, 8, ["modelValue", "name"])
          ])
        ]),
        _: 1
      }, 16))
    : (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 1 }, zoneCopy.value)), {
        default: _withCtx(() => [
          _createVNode(PillRadioGroup, {
            modelValue: _unref(wizard).data.zone.kind,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_unref(wizard).data.zone.kind) = $event)),
            label: zoneCopy.value.title,
            options: kindOptions.value
          }, null, 8, ["modelValue", "label", "options"]),
          (_unref(wizard).data.zone.kind === 'map')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "m-0 mb-2 text-sm text-gray-600" }, " Click the map to draw the area you deliver to. At least three points. ", -1)),
                _createVNode(GoogleMapComponent, {
                  modelValue: _unref(wizard).data.zone.waypoints,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_unref(wizard).data.zone.waypoints) = $event)),
                  mode: "region"
                }, null, 8, ["modelValue"])
              ]))
            : (_unref(wizard).data.zone.kind === 'zips')
              ? (_openBlock(), _createBlock(ZipCodeList, {
                  key: 1,
                  modelValue: _unref(wizard).data.zone.zipCodes,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_unref(wizard).data.zone.zipCodes) = $event)),
                  length: zipLength.value
                }, null, 8, ["modelValue", "length"]))
              : (_unref(wizard).data.zone.kind === 'states')
                ? (_openBlock(), _createBlock(MultiSelectInput, {
                    key: 2,
                    modelValue: _unref(wizard).data.zone.states,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_unref(wizard).data.zone.states) = $event)),
                    options: stateOptions.value,
                    placeholder: `Pick ${stateWords.value.many}`
                  }, null, 8, ["modelValue", "options", "placeholder"]))
                : _createCommentVNode("", true),
          (listKind.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(ONE_KIND_NOTE)))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16))
}
}

}